/**
 * Извлекает тип ипотеки из массива типов промо-поиска
 */
export function getMortgageType(promoSearchTypes: string[]): string | undefined {
  const mortgageTypes = ['standardMortgage', 'familyMortgage', 'itMortgage'];

  return promoSearchTypes.find(type => mortgageTypes.includes(type));
}
